module.exports = __webpack_public_path__ + "img/heart.502189ae.svg";